<template>
  <div id="about " class="bg-white">
    <!-- <Head></Head> -->
    <section class="w">
      <div class="about f-b fw-w">
        <div class="about-article">
          <h1 class="part-title animated wow fadeInUp">{{ $t('Home.About.AboutUs') }}</h1>
          <p class="animated wow fadeInUp">
            {{ $t('Home.About.Tips1') }}
          </p>
          <p class="animated wow fadeInUp">
            {{ $t('Home.About.Tips2') }}
            </p>
          <p>
            {{ $t('Home.About.Tips3') }}
          </p>
        </div>
        <div class="about-img">
          <!-- <img src="@/assets/img/homePage/company-us.png" alt="" lazy  /> -->
          <oss-img src="https://img.kakaclo.com/web-img/company-us.jpg" width="549" heigth="492" />
          <div class="color-bar_1"></div>
          <div class="color-bar_2"></div>
          <div class="color-bar_3"></div>
        </div>
      </div>
      <TeamDescription></TeamDescription>
      <div class="iframe-box">
        <h1 class="part-title tc animated wow fadeInUp delay01">
          {{ $t('Home.About.Tips4') }}
        </h1>
        <div class="iframe">
          <iframe
            width="100%"
            class=" animated wow fadeInUp delay02"
            :height="height"
            src="https://www.youtube.com/embed/HIzYm2IIuOg"
            :title="$t('Home.About.YouTubeVideoPlayer')"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="our-blog f-b-c fw-w">
        <div class="switch-box">
          <h1 class="part-title animated wow fadeInUp">{{ $t('Home.About.OurBlog') }}</h1>
          <p class="part-s-title animated wow fadeInUp">{{ $t('Home.About.Tips5') }}</p>
        </div>
        <div class="blogs f-b-c">
          <div v-for="(item,index) in essayList" :key="index" class="blog-card animated wow fadeInUp delay02">
            <a :href="item.url" style="color:#121E26;font-size: 18px;">
              <div class="blog-img">
                <!-- <img :src="item.imgUrl" alt="" lazy > -->
                <oss-img :src="item.img_url" width="562" heigth="400" />
              </div>
              <div class="blog-article">
                <div class="blog-time">
                  <i class="iconfont icon-calendar-2-line" style=""></i>
                  <span>{{item.date}}</span>
                </div>
                <h6 class="blog-title ellipsis2">{{item.title}}</h6>
                <p class="blog-content ellipsis2">{{item.title}}</p>
                <p style="color:#121E26;font-size: 18px;">{{ $t('Home.About.ReadMore') }}</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
    <RegisterRoute></RegisterRoute>
    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
import API from '@/api'
import { dateFormat } from '@/util/date'
import { WOW } from 'wowjs'
// import Head from './components/Head'
// import Footer from './components/Footer'
import TeamDescription from './components/TeamDescription'
import RegisterRoute from './components/RegisterRoute'
export default {
  metaInfo: {
    title: 'About Us - KakaClo',
    meta: [
      {
        name: 'description',
        content: 'KakaClo is the industry-leading apparel supply chain platform that focuses on providing customers with in stock apparel custom production and dropshipping service.'
      }
    ]
  },
  components: { RegisterRoute, TeamDescription },
  data() {
    return {
      screenWidth: 0,
      height: 0,
      essayForm: {
        pageNumber: 1,
        pageSize: 2,
        labelName: 'Blog'
      },
      essayList: []
    }
  },
  created() {
    this.getEssayList()
  },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      var wow = new WOW({
        boxClass: 'wow', // /动画元件css类（默认为wow）
        animateClass: 'animated', // 动画css类（默认为animated）
        offset: 0, // 到元素距离触发动画（当默认为0）
        mobile: true, // 在移动设备上触发动画（默认为true）
        live: true // 对异步加载的内容进行操作（默认为true）
      })
      wow.init()
    })
    this.screenWidth = window.innerWidth
    this.setSize()
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      this.screenWidth = window.innerWidth
      this.setSize()
      this.$forceUpdate()
    }
  },
  methods: {
    setSize() {
      this.$forceUpdate()
      if (this.screenWidth < 500) {
        this.height = 320
      } else if (this.screenWidth < 750) {
        this.height = 350
      } else if (this.screenWidth < 1000) {
        this.height = 500
      } else if (this.screenWidth < 1200) {
        this.height = 550
      } else if (this.screenWidth < 1400) {
        this.height = 620
      } else if (this.screenWidth < 1600) {
        this.height = 680
      } else {
        this.height = 720
      }
    },
    getEssayList() {
      API.getEssayList(this.essayForm).then(res => {
        this.essayList = res.data.list
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import './css/homeOld.scss';
#about {
  font-family: 'Poppins', 'PingFang SC', 'Sen', 'Helvetica', 'Arial', 'Sans-serif';
  padding-top: 50px;
}

.about-img {
  width: 45%;
  height: 0;
  padding-bottom: 45%;
  position: relative;
  img {
    width: 87%;
    position: absolute;
    object-fit: contain;
    left: 30px;
    top: 10%;
    z-index: 10;
    --positionX: 0;
    --positionY: 0;
  }
  .color-bar_1 {
    width: 40%;
    padding-top: 40%;
    background: #99c41c;
    position: absolute;
    left: 0;
    top: 26px;
  }
  .color-bar_2 {
    width: 18%;
    padding-top: 18%;
    background: rgba(221, 220, 223, 0.27);
    position: absolute;
    left: 30%;
    top: 0px;
  }
  .color-bar_3 {
    width: 35%;
    padding-top: 35%;
    background: rgba(139, 147, 163, 0.34);
    position: absolute;
    right: 0;
    bottom: 0;
  }
}
.about {
  padding: 70px 0 115px 0;
}
.about-article {
  width: 45%;
  margin-right: 15px;
  h1 {
    padding-bottom: 15px;
  }
  p {
    font-size: 16px;
    font-weight: 400;
    line-height: 40px;
    color: #666666;
    margin-bottom: 20px;
  }
}

.our-blog {
  margin-bottom: 60px;
}
.switch-box {
  width: 30%;
}
.blogs {
  width: 68%;
}
article {
  padding: 0 27px 27px 27px;
}
.blog-article {
  padding: 0 27px 27px;
}
.blog-card {
  width: 48%;
  max-height: 569px;
  background: #ffffff;
  box-shadow: 0px 3px 30px rgba(0, 0, 0, 0.09);
  border-radius: 12px;
  margin-bottom: 3%;
  overflow: hidden;
  color: #121e26;
}
.blog-img {
  width: 100%;
  height: 65%;
  img {
    width: 100%;
  }
}
.blog-time {
  line-height: 39px;
  color: #121e26;
  font-size: 16px;

  font-weight: 400;
  i {
    color: #99c41c;
    font-size: 20px;
    margin-right: 5px;
  }
}
.blog-title {
  margin: 15px 0 18px 0;
  height: 50px;
  font-size: 20px;
  font-weight: 600;
  line-height: 25px;
}
.blog-content {
  font-size: 16px;
  font-weight: 400;
  height: 50px;
  line-height: 25px;
  margin-bottom: 27px;
}
.iframe-box {
  padding-bottom: 120px;
  h1 {
    padding-bottom: 45px;
  }
}
.iframe {
  width: 100%;
  height: 750px;
  margin: 0 auto;
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 1600px) {
  .iframe {
    height: 680px;
  }
}
@media screen and (max-width: 1400px) {
  .iframe {
    height: 620px;
  }
}
@media screen and (max-width: 1200px) {
  .iframe {
    height: 550px;
  }
  .about-article {
    width: 48%;
  }
  .about-img {
    width: 48%;
  }
}
@media screen and (max-width: 1000px) {
  .blogs {
    width: 100%;
  }
  .iframe {
    height: 500px;
  }
  .about-article {
    p {
      font-size: 16px;
      line-height: 34px;
    }
  }
  .switch-box {
    text-align: center;
    p {
      padding-bottom: 16px;
    }
  }
  .about {
    padding: 0;
    padding-bottom: 60px;
  }
  .switch-box {
    width: 100%;
  }
  .blog-card {
    width: 48%;
  }
}

@media screen and(max-width:850px) {
  .about-img {
    width: 80%;
    padding-bottom: 80%;
    margin: 0 auto;
  }
  .about-article {
    width: 100%;
    margin: 0;
    h1 {
      text-align: center;
    }
  }
  .team-title {
    max-width: 90%;
    margin: 0 auto;
    font-size: 18px;
  }
  .team-s-title {
    max-width: 90%;
    margin: 0 auto;
    font-size: 14px;
  }
}

@media screen and(max-width:750px) {
  .iframe {
    height: 350px;
  }
  .blog-article {
    padding: 0 15px 15px;
  }
  .blog-time {
    font-size: 14px;
  }

}
@media screen and(max-width:500px) {
  .iframe {
    height: 320px;
  }
}
</style>
